import { InlineFormInput } from '@platform/components';
import { useState } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';

type PasswordInputProps = {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  register: UseFormRegister<any>;
  password: string;
  errors: FieldError | undefined;
  hideRequirements?: boolean;
  label?: string;
  registerKey?: string;
  placeholder?: string;
};

export const SetPasswordInput = (props: PasswordInputProps) => {
  const { register, errors, password, hideRequirements, label, registerKey, placeholder } = props;

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const formValidation = {
    required: { value: true, message: 'Password is required' },
    length: {
      value: 8,
      message: 'Password must have a minimum of 8 characters and one uppercase letter',
    },
    pattern: {
      value: /[A-Z]/,
      message: 'Password must have a minimum of 8 characters and one uppercase letter',
    },
  };
  return (
    <div className='flex flex-col gap-2'>
      <InlineFormInput
        label={label ?? 'Password'}
        placeholder={placeholder ?? 'Create an 8 character password'}
        buttonText='Show'
        buttonOnPress={() => setIsPasswordVisible(!isPasswordVisible)}
        inputType={isPasswordVisible ? 'text' : 'password'}
        register={() => {
          return register(registerKey ?? 'password', formValidation);
        }}
        autocomplete='new-password'
        errors={errors}
      />
      {!hideRequirements && !password && !errors?.message && (
        <div className='flex flex-row gap-2 h-5 text-gray-400 text-sm'>
          Minimum of 8 characters and one uppercase letter
        </div>
      )}
    </div>
  );
};
